import { render, staticRenderFns } from "./PharmacyGroupsIndexComponent.vue?vue&type=template&id=da62423e"
import script from "./PharmacyGroupsIndexComponent.vue?vue&type=script&lang=js"
export * from "./PharmacyGroupsIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports